const common = {
  'nav.home': 'Inicio',
  'nav.guide': 'Guía de compra',
  'nav.categories': 'Categorías',
  'nav.visitMain': 'Visitar el sitio principal',

  'lang.en': 'English',
  'lang.fr': 'Français',
  'lang.es': 'Español',
  'lang.pl': 'Polski',

  'category.shoes': 'Zapatillas',
  'category.hoodies': 'Sudaderas',
  'category.tshirts': 'Camisetas',
  'category.jackets': 'Chaquetas',
  'category.pants': 'Pantalones y Shorts',
  'category.headwear': 'Gorros',
  'category.sets': 'Conjuntos',
  'category.underwear': 'Ropa interior',
  'category.jersey': 'Camisetas deportivas',
  'category.accessories': 'Accesorios',
  'category.bags': 'Bolsos',
  'category.belts': 'Cinturones',
  'category.perfumes': 'Perfumes',
  'category.other': 'Otros artículos',

  'footer.tagline': 'Un centro de recursos USFans independiente.',
  'footer.quickLinks': 'Enlaces rápidos',
  'footer.categoriesTitle': 'Categorías',
  'footer.legal': 'Legal',
  'footer.disclaimerTitle': 'Aviso legal',
  'footer.disclaimerText': 'USFansLink es un recurso informativo independiente. No garantizamos la exactitud, seguridad ni legitimidad de cada vendedor, enlace, entrada de la hoja de cálculo, cupón o código de descuento de terceros. Verifique siempre la información de forma independiente.',
  'footer.rights': 'Todos los derechos reservados.',
};

export default common;